export class NavItem {
    name: string;
    href: string;
    iconClass: string;
    categoryClass: string;
    target: string;

    constructor(name?: string, href?: string, iconClass?: string, categoryClass?: string, target?: string) {
        this.name = name;
        this.href = href;
        this.iconClass = iconClass;
        this.categoryClass = categoryClass;
        this.target = target;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/nav-item.ts